module.exports = __webpack_public_path__ + "media/stop-5.9a5928c3.mp3";